module.exports = __webpack_public_path__ + "static/media/sakshi_powar.1b8e5fe5.png";